/**
 * Admin Reseller control module
 */
import { API_URL, requestData } from "./utils";

export default class ResellerModule {
  add(params) {
    return requestData("POST", `/reseller`, { reseller: params });
  }
  get(reseller_id) {
    return requestData("GET", `/reseller/${reseller_id}`);
  }
  getQuery(query) {
    return requestData("GET", `/query/reseller`, { ...query });
  }
  getResellersCsvURL(
    query,
    selectedResellerType,
    link = `/download/csv/resellers/${selectedResellerType}`,
  ) {
    return API_URL + link + "?" + new URLSearchParams(query);
  }
  requestQueryLink(query, link = "/query/reseller", abortSignal) {
    return requestData("GET", link, query, undefined, abortSignal);
  }
  getResellerType(){
    return requestData("GET", `/query/reseller/type`);
  }
  update(reseller, reseller_id) {
    return requestData("PUT", `/reseller/${reseller_id}`, {
      ...reseller,
    });
  }
  delete(reseller, reseller_id) {
    return requestData("DELETE", `/reseller/${reseller_id}`, {
      ...reseller,
    });
  }
  
}
